import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import api, { imgUrl, track } from "@/lib/api";
import Navbar from "@/components/public/Navbar";
import Footer from "@/components/public/Footer";

export default function BlogList() {
  const [posts, setPosts] = useState([]);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    track("page_view", "/blog");
    api.get("/blog").then((r) => setPosts(r.data));
    api.get("/settings").then((r) => setSettings(r.data));
  }, []);

  return (
    <div className="relative min-h-screen bg-[#09090B] text-white">
      <div className="grain" />
      <Navbar settings={settings} />
      <section className="pt-36 pb-24 max-w-7xl mx-auto px-6 lg:px-8">
        <p className="text-sm uppercase tracking-[0.3em] text-yellow-400 font-semibold mb-3">Le blog</p>
        <h1 className="font-display text-5xl sm:text-6xl font-black tracking-tighter mb-12">Conseils & inspirations</h1>

        {posts.length === 0 && <p className="text-zinc-500">Aucun article pour le moment.</p>}

        <div className="grid md:grid-cols-3 gap-8">
          {posts.map((p, i) => (
            <motion.div key={p.id} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.05 }}>
              <Link to={`/blog/${p.slug}`} data-testid="blog-card" className="group block rounded-2xl overflow-hidden bg-zinc-900/60 border border-white/10 hover:border-yellow-400/40 transition-colors">
                <div className="aspect-[16/10] overflow-hidden bg-zinc-800">
                  {p.cover_url && <img src={imgUrl(p.cover_url)} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />}
                </div>
                <div className="p-6">
                  <h2 className="font-display text-xl font-bold mb-2 group-hover:text-yellow-400 transition-colors">{p.title}</h2>
                  <p className="text-zinc-400 text-sm line-clamp-3">{p.excerpt}</p>
                  <span className="mt-4 inline-flex items-center gap-2 text-yellow-400 text-sm font-medium">
                    Lire l'article <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </span>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </section>
      <Footer settings={settings} />
    </div>
  );
}
